import styled from "styled-components";
import { secondaryColor } from "../../../config";

export const BackToAdminWrapper = styled.button`
  
`;
export const ProfileView = styled.div`
 display:block
`;
